import type { FunctionComponent } from "react";

import { Container, Copyright, StyledScmpLogoFlag } from "./styles";

type Props = {
  className?: string;
};

export const PrintArticleFooter: FunctionComponent<Props> = ({ className }) => (
  <Container className={className}>
    <StyledScmpLogoFlag />
    <Copyright>
      Copyright © {new Date().getFullYear()} South China Morning Post Publishers Ltd. All rights
      reserved.
    </Copyright>
  </Container>
);

PrintArticleFooter.displayName = "PrintArticleFooter";
